module.exports = __webpack_public_path__ + "img/3.b819d1ee.jpg";